import React from 'react';
import PropTypes from 'prop-types';
import AngleDown from '../icons/AngleDown';
import UserHelper from '../../helpers/UserHelper';
import * as Roles from '../../resources/UserRole';
import { withCartConfig } from '../../hooks/CartConfigContext';

export class FreightHandlingCodes extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    setMountedState = (state, callback) => {
        if (this.mounted)
            this.setState(state, () => callback && callback());
    }

    render() {
        const { localized } = this.props;
        let isDisabled = this.props.isFetching || !UserHelper.hasRoles([Roles.CAN_SELECT_FREIGHT_CODES], this.props.currentUser) || this.props.CartConfig.freightHandlingCodes.length === 1;
        return (
            this.props.CartConfig.freightHandlingCodes.length > 0 && this.props.CartConfig.childComponents.HeaderFreightHandlingCodes.shown &&
            <React.Fragment>
                    <div className="fele-cart-freight-handling-codes" style={{ opacity: isDisabled ? .5 : 1 }} >
                    <div className="label">
                        {localized.FreightHandlingCodesLabel}
                    </div>
                    <div className="fele-content">
                            <div className="input-wrapper">
                                <div className="select-wrapper" style={{ opacity: isDisabled ? 0.5 : 1 }}>
                                    <select
                                        disabled={isDisabled}
                                        onChange={this.props.handleChange}
                                        value={this.props.freightHandlingCode}
                                        style={{ cursor: isDisabled ? 'default' : 'pointer' }}
                                    >
                                    {
                                            this.props.CartConfig.freightHandlingCodes.length === 1 ?
                                                <option value={this.props.freightHandlingCode ?? this.props.CartConfig.freightHandlingCodes[0].id} > {this.props.CartConfig.freightHandlingCodes[0].description}</option> :
                                        <option value={0} > {localized.SelectFreightHandlingCode}</option>
                                    }
                                    {
                                        this.props.CartConfig.freightHandlingCodes.map(
                                            (freightHandlingCode, index) =>
                                                <option key={index} value={freightHandlingCode.id}>{freightHandlingCode.description}</option>
                                        )}
                                    </select>
                                    {!isDisabled && <AngleDown />}
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}


FreightHandlingCodes.propTypes = {
    handleChange: PropTypes.func,
    currentUser: PropTypes.object,
    freightHandlingCode: PropTypes.string,
};

export default withCartConfig(FreightHandlingCodes);
